<template>
    <div class="py-4">
        <div class="flex">
            <div class="w-[50%] px-2 lg:px-4 text-[12px] lg:text-[14px] font-bold">
                {{ item.list_type }}
            </div>
            <div class="w-[25%] px-2 lg:px-4 text-[12px] lg:text-[14px] font-bold">
                {{ item.leads | formatNumber("1,000") }}
            </div>
            <div class="w-[25%] px-2 lg:px-4 text-[12px] lg:text-[14px] font-bold">
                {{ item.price | formatNumber("1,000.00", "$") }}

                <p v-if="item.credit.method === 'split'"
                   class="mb-0 text-gray-400 text-[10px] leading-snug">
                    ( {{ item.credit.description }} )
                </p>
            </div>
        </div>

        <div class="my-2 px-2 lg:px-4" @click="showItems = !showItems">
            <div
                class="inline-block relative text-gray-400 text-[14px] underline hover:no-underline pr-6 cursor-pointer">
                <template v-if="!showItems">Show</template>
                <template v-else>Hide</template>
                Selected Options
                <icon-arrow class="right-1 arrow-toggle" :class="{'arrow-toggle-hide': !showItems}"  uiobject="old"/>
            </div>
        </div>

        <div class="px-2 lg:px-4" v-if="showItems">
            <template v-if="items.length">
                <div class="text-gray-400 text-[12px] lg:text-[14px]"
                     v-for="item in items"
                     :key="item.key">
                    {{ item.title }}

                    <div v-if="item.sensitive"
                         class="inline-block bg-gray-200 text-[11px] rounded-full px-2 py-[5px] leading-none">
                        Sensitive Data
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { v4 as uuidv4 } from "uuid";

    export default {
        name: "cart-item",
        props: {
            item: {
                required: true,
                type: Object
            }
        },
        computed: {
            selectedData () {
                return this.$store.getters["widgetData/getSelectedDataForUI"];
            },
            subAudienceEmail () {
                return this.selectedData.subAudience.code.includes("_email");
            },
            geoEmpty () {
                return !this.selectedData.selects.find(item => item.code.includes("_geo_search") || item.code.includes("_zip_radius") || item.code.includes("_mapping"));
            },
            items () {
                let items = [...this.item.selects];
                if (this.geoEmpty) {
                    items.unshift({
                        key: uuidv4(),
                        title: "Whole USA"
                    });
                }
                if (this.subAudienceEmail) {
                    items.unshift({
                        key: uuidv4(),
                        title: "Must have email"
                    });
                }
                return items;
            }
        },
        data () {
            return {
                showItems: true
            };
        }
    };
</script>
